import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetFarmersFullQuery } from "features/onboarding/users/farmer/farmerApiSlice";
var myIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -30],
});

const getColor = (ACS) => {
  if (ACS === null) return "blue";
  if (ACS < 50) return "red";
  if (ACS >= 50 && ACS <= 60) return "yellow";
  return "green";
};

const HclMapFullAdmin = (props) => {
  const navigate = useNavigate();
  const [geoJson, setGeoJson] = useState();
  const [geoJson2, setGeoJson2] = useState(null);

  const { data: data, isLoading, isFetching, refetch } = useGetFarmersFullQuery(
    {
    orgId :"cc5dc645-6e1e-4f4f-a476-4b87480dc5db",
      
    },
    { refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (data != undefined) {
      const GeojsonData = data?.data?.geojson ? data?.data?.geojson : null;
      setGeoJson(GeojsonData);
    }
  }, [data]);
  useEffect(() => {
    fetch(
      "https://lc-research-projects.s3.ap-south-1.amazonaws.com/maati/prayagraj_block_boundaries.geojson"
    ).then((resp) => {
      resp.json().then((geoJsonData) => {
        setGeoJson2(geoJsonData);
      });
    });
  }, []);
  console.log("props?.RoleAcessParams",props?.RoleAcessParams)

  useEffect(() => {
    const map = L.map("mapIdd", {
      center: [28.6591285, 77.3165729],
      zoom: 6,
    });

    const googleSatellite = L.tileLayer(
      "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",
      { maxZoom: 22, attribution: "© Google Maps" }
    ).addTo(map); 

    const streetLayer = L.tileLayer(
      "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
      { maxZoom: 22, attribution: "© Google" }
    );

    let cropMask;
    let boundaryLayer;

      cropMask = L.tileLayer(
        "https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=https%3A%2F%2Flc-research-projects.s3.ap-south-1.amazonaws.com%2Fmaati%2Fprayagraj_v1_crop_mask_v3.tif&colormap=%7B%221%22%3A+%22%2338761D%22%2C+%222%22%3A+%22%23B7E1CD%22%7D",
        { tms: false, maxZoom: 22 }
      ).addTo(map);

      boundaryLayer = L.geoJSON(geoJson2, {
        style: { fillOpacity: 0, color: "red", weight: 1 },
        onEachFeature: (feature, layer) => {
          if (!layer) return;
          layer.on({
            click: () => {
              map.fitBounds(L.geoJSON(feature).getBounds());
            },
          });
        },
      }).addTo(map);
    

    var markersBar = L.markerClusterGroup();
    var barLayer = new L.geoJson(geoJson, {
      style: (feature) => ({
        color: getColor(feature.properties.ACS),
        weight: 2,
        fillOpacity: 0.5,
      }),
      pointToLayer: function(feature, latlng) {
        return L.marker(latlng, { icon: myIcon });
      },
      onEachFeature: function(feature, layer) {
        const Wrapperdiv = document.createElement("div");
        Wrapperdiv.className = "farmer-info-wrapper";

        Wrapperdiv.innerHTML = `<div className="farmerName"> 
            <div><b>Farmer Name </b>: ${
              feature.properties.farmer_name
            }</div><br/>
            <div><b> Mobile Number </b>:<span> ${
              feature.properties.phone_number
            }</span></div><br/>
            <div><b> State </b>: ${feature.properties.state_name}</div><br/>
            <div><b> District </b>: ${
              feature.properties.district_name
            }</div><br/>
            <div><b> Land Mark </b>: ${feature.properties.land_mark}</div><br/>
            <b> Farm Score  </b>: ${
              feature.properties.ACS === null ? 0 : feature.properties.ACS
            }
          </div>`;

        const button = document.createElement("button");
        button.innerHTML = "View Details";
        button.style.cssText =
          "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";
        button.onclick = function() {
          {
            props?.newAdminHcl
              ? navigate(
                  `/farmerDetails/onboarding/${feature.properties.farmer_id}`,
                  {
                    state: { fullname: "" },
                  }
                )
              : navigate(
                  `/farmerDetail/onboarding/${feature.properties.farmer_id}`,
                  {
                    state: { fullname: "" },
                  }
                );
          }
        };

        layer.on({
          click: () => {
            map.fitBounds(L.geoJSON(feature).getBounds());
          },
        });

        Wrapperdiv.appendChild(button);
        return layer.bindPopup(Wrapperdiv);
      },
    });

    markersBar
      .addLayer(barLayer)
      .addTo(map)
      .bringToFront();

    const baseLayers = {
      "Google Satellite": googleSatellite,
      "Google Street View": streetLayer,
    };

    const overlayLayers = {
      "Crop Mask": cropMask ,
     
        Boundary: boundaryLayer,
   
      Plots: markersBar,
    };
       L.control.layers(baseLayers, overlayLayers, { collapsed: false }).addTo(map);
   
    const legend = L.control({ position: "bottomright" });

    legend.onAdd = function (map) {
      const div = L.DomUtil.create("div", "info legend custom-legend");
      // const grades = ["High (>60)", "Moderate( >= 50 && <= 60)", "Low (<50)"];
      const grades = ["High", "Moderate", "Low"];


      const colors = ["green", "yellow", "red"];
    
      let labels = ["<h6 style='margin-bottom: 10px;'>Farm Score</h6>"];
      for (let i = 0; i < grades.length; i++) {
        labels.push(
          `<div style="display: flex; align-items: center; margin-bottom: 8px;">
            <i style="background:${colors[i]}; width:18px; height:18px; display:inline-block; margin-right:8px; border:1px solid #000;"></i> 
            <span style="font-size:14px;">${grades[i]}</span>
          </div>`
        );
      }
      div.innerHTML = labels.join("");
      return div;
    };
    
    legend.addTo(map);
    if (props?.RoleAcessParams.includes("admin") && geoJson2) {
      map.fitBounds(L.geoJson(geoJson2).getBounds());
    } else if (geoJson && geoJson.features?.length) {
      map.fitBounds(L.geoJSON(geoJson).getBounds());
    }

    return () => {
      map.off();
      map.remove();
    };
  }, [geoJson, geoJson2, navigate]);

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
      id="mapIdd"
      className="farmer_map"
    >
      
    </div>
  );
};

export default HclMapFullAdmin;
